import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ListResponse } from '@ca/core/models';
import { ModuleComplianceV1Read } from '../models/module-compliance-v1-read.model';

@Injectable({
    providedIn: 'root',
})
export class ModuleCompliancesV1Service {
    apiUrl = 'module_manager/v1/public/modulecompliances';

    constructor(private http: HttpClient) {}

    getCompliances(): Observable<ModuleComplianceV1Read[]> {
        return this.http
            .get('/api/module_manager/v1/public/modulecompliances', { headers: { 'Content-Type': 'application/query.api+json' } })
            .pipe(map((res: ListResponse<ModuleComplianceV1Read>) => res.data));
    }

    protected createNewInstance(): ModuleComplianceV1Read {
        return new ModuleComplianceV1Read();
    }
}
